import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ZonaCargando from "../alertas/zonaCargando";

const BADGE_TIPO = {
    Usuario:      { bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)" },
    Soporte:      { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)" },
    Moderador:    { bg: "rgba(var(--violeta-bootstrap-rgb), 0.1)",  color: "var(--violeta-bootstrap)" },
    Contador:     { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado)" },
    Administrador:{ bg: "rgba(var(--naranja-mapa-rgb), 0.1)",  color: "var(--naranja-mapa)" },
    SuperAdmin:   { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)" },
};

const ESTADO_RESERVA = {
    hold:       { label: "En espera",   cls: "bg-warning-subtle text-warning-emphasis border border-warning-subtle" },
    confirmado: { label: "Confirmado",  cls: "bg-success-subtle text-success-emphasis border border-success-subtle" },
    cancelado:  { label: "Cancelado",   cls: "bg-danger-subtle text-danger-emphasis border border-danger-subtle" },
    completado: { label: "Completado",  cls: "bg-primary-subtle text-primary-emphasis border border-primary-subtle" },
    expirado:   { label: "Expirado",    cls: "bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle" },
};

const VERIFICACION_ESTADO = {
    inicio:    { label: "Sin iniciar",  cls: "bg-secondary-subtle text-secondary-emphasis" },
    pendiente: { label: "Pendiente",    cls: "bg-warning-subtle text-warning-emphasis" },
    aprobado:  { label: "Aprobado",     cls: "bg-success-subtle text-success-emphasis" },
    rechazado: { label: "Rechazado",    cls: "bg-danger-subtle text-danger-emphasis" },
};

function val(v) {
    return (!v || v === "NA" || v === "0" || v === 0) ? null : v;
}

function Fila({ label, value, icon }) {
    if (!value && value !== 0) return null;
    return (
        <div className="d-flex align-items-start gap-2 py-2 border-bottom" style={{ borderColor: "var(--color-track-bg) !important" }}>
            {icon && <i className={`bi ${icon} text-muted mt-1`} style={{ minWidth: 18 }}></i>}
            <div className="flex-grow-1">
                <div className="text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>{label}</div>
                <div className="text-dark" style={{ fontSize: "0.9rem" }}>{value}</div>
            </div>
        </div>
    );
}

function SeccionTitulo({ icon, title }) {
    return (
        <div className="d-flex align-items-center gap-2 mb-3 mt-2">
            <i className={`bi ${icon} text-primary`}></i>
            <h6 className="mb-0 fw-bold text-dark">{title}</h6>
        </div>
    );
}

function formatearFecha(fecha) {
    if (!fecha) return null;
    return new Date(fecha).toLocaleString("es-CO", {
        day: "2-digit", month: "short", year: "numeric",
        hour: "2-digit", minute: "2-digit",
    });
}

function UsuarioIndividual() {
    const location = useLocation();
    const navigate = useNavigate();
    const [stateParams] = useState(() => {
        if (location.state?.params) return location.state.params;
        try {
            const stored = localStorage.getItem("admin_nav_usuario");
            if (stored) { localStorage.removeItem("admin_nav_usuario"); return JSON.parse(stored); }
        } catch {}
        return {};
    });
    const { username, idUsuario } = stateParams;

    const [usuario, setUsuario] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(null);

    const [tabReservas, setTabReservas] = useState("comprador");
    const [reservasComprador, setReservasComprador] = useState({ data: [], loaded: false, cargando: false });
    const [reservasProveedor, setReservasProveedor] = useState({ data: [], loaded: false, cargando: false });

    const [servicios, setServicios]         = useState([]);
    const [cargandoSrv, setCargandoSrv]     = useState(false);
    const [creandoSrv, setCreandoSrv]       = useState(false);

    async function fetchReservas(rol, idUsuario) {
        const setter = rol === "comprador" ? setReservasComprador : setReservasProveedor;
        setter((prev) => ({ ...prev, cargando: true }));
        try {
            const res = await axios.post("/obtener-reservas-usuario-admin", { params: { idUsuario, rol: rol === "comprador" ? "comprador" : "proveedor" } });
            setter({ data: res?.data?.reservas || [], loaded: true, cargando: false });
        } catch {
            setter({ data: [], loaded: true, cargando: false });
        }
    }

    function cambiarTabReservas(tab) {
        setTabReservas(tab);
        if (tab === "comprador" && !reservasComprador.loaded) fetchReservas("comprador", usuario?.idUsuario);
        if (tab === "proveedor" && !reservasProveedor.loaded) fetchReservas("proveedor", usuario?.idUsuario);
    }

    useEffect(() => {
        if (!usuario?.idUsuario) return;
        fetchReservas("comprador", usuario.idUsuario);
        (async () => {
            try {
                setCargandoSrv(true);
                const res = await axios.post("/obtener-servicio-usuario-admin", { params: { idUsuario: usuario.idUsuario } });
                const todos = res.data.servicios || [];
                setServicios(todos.filter(s => s.estado === "Borrador" || s.estado === "Aprobado"));
            } catch { setServicios([]); }
            finally { setCargandoSrv(false); }
        })();
    }, [usuario?.idUsuario]);

    useEffect(() => {
        if (!username && !idUsuario) {
            setError("No se especificó un usuario.");
            setCargando(false);
            return;
        }

        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/obtener-usuario-admin", {
                    params: { username, idUsuario },
                });
                if (res?.data?.exito) {
                    setUsuario(res.data.usuario);
                } else {
                    setError(res?.data?.mensaje || "No se encontró el usuario.");
                }
            } catch (err) {
                setError("No se pudo cargar la información del usuario.");
            } finally {
                setCargando(false);
            }
        })();
    }, [username, idUsuario]);

    if (cargando) return <ZonaCargando />;

    if (error) {
        return (
            <div className="container-fluid">
                <div className="pt-3 pb-2 mb-4 border-bottom">
                    <button type="button" className="btn btn-link ps-0 text-muted" onClick={() => navigate(-1)}>
                        <i className="bi bi-arrow-left me-1"></i>Volver
                    </button>
                </div>
                <div className="text-center py-5">
                    <i className="bi bi-person-x fs-1 text-muted"></i>
                    <p className="text-muted mt-2">{error}</p>
                </div>
            </div>
        );
    }

    if (!usuario) return null;

    const u = usuario;

    async function crearServicioParaUsuario() {
        try {
            setCreandoSrv(true);
            const res = await axios.post("/crear-servicio-borrador", {
                params: { usuario: { username: u.username, idUsuario: u.idUsuario } },
            });
            if (res.data?.idServicio) {
                navigate("/admin/servicio", { state: { params: { idServicio: res.data.idServicio } } });
            }
        } catch {
            /* silencioso */
        } finally {
            setCreandoSrv(false);
        }
    }

    const nombreCompleto = [val(u.nombre), val(u.apellido)].filter(Boolean).join(" ") || "Sin nombre";
    const estiloTipo = BADGE_TIPO[u.tipo] || BADGE_TIPO.Usuario;
    const verfEstado = VERIFICACION_ESTADO[u.verificacionIdentidad?.estado] || VERIFICACION_ESTADO.inicio;
    const tieneProfesional = u.perfilProfesional?.completo || val(u.perfilProfesional?.profesionPrincipal) || val(u.perfilProfesional?.tituloProfesional);
    const tieneBancaria = u.cuentasBancarias?.length > 0;
    const tieneWallets = u.wallets?.length > 0;
    const dispositivosActivos = (u.tokensFirebase || []).filter((t) => t.activo);

    return (
        <div className="container-fluid">
            {/* Header */}
            <div className="d-flex align-items-center gap-2 pt-3 pb-2 mb-4 border-bottom">
                <button type="button" className="btn btn-link ps-0 text-muted" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left me-1"></i>Volver
                </button>
            </div>

            <div className="row g-4">
                {/* Columna izquierda: perfil básico */}
                <div className="col-12 col-lg-4">
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                            {/* Avatar y nombre */}
                            <div className="text-center mb-4">
                                <div className="position-relative d-inline-block mb-3">
                                    <img
                                        src={val(u.avatar) || "/imagenes/marca/avatar.png"}
                                        alt={nombreCompleto}
                                        className="rounded-circle"
                                        style={{ width: 96, height: 96, objectFit: "cover" }}
                                    />
                                    {u.verificacionIdentidad?.estado === "aprobado" && (
                                        <img
                                            src="https://zervicy.s3.us-east-1.amazonaws.com/imagenes/iconos/autenticado.svg"
                                            alt="Verificado"
                                            width="24"
                                            height="24"
                                            style={{ position: "absolute", top: -2, left: -4 }}
                                        />
                                    )}
                                </div>
                                <h2 className="h5 fw-bold text-dark mb-1">{nombreCompleto}</h2>
                                <div className="d-flex justify-content-center gap-2 flex-wrap mb-3">
                                    <span className="badge rounded-pill px-3 py-2" style={{ background: estiloTipo.bg, color: estiloTipo.color }}>
                                        {u.tipo}
                                    </span>
                                    <span className="badge rounded-pill px-3 py-2 bg-light text-secondary border">
                                        {u.modo || "Comprador"}
                                    </span>
                                </div>

                                {/* Validaciones */}
                                <div className="d-flex justify-content-center gap-1 flex-wrap">
                                    {[
                                        { ok: u.perfilPersonalCompleto,                              label: "Perfil personal", icon: "bi-person-check-fill" },
                                        { ok: u.infoBancariaCompleta,                                label: "Info bancaria",   icon: "bi-bank2" },
                                        { ok: u.verificacionIdentidad?.estado === "aprobado",        label: "Identidad",       icon: "bi-patch-check-fill" },
                                    ].map(({ ok, label, icon }) => (
                                        <span
                                            key={label}
                                            className={`badge rounded-pill border px-2 py-1 ${ok ? "bg-success-subtle text-success-emphasis border-success-subtle" : "bg-light text-muted"}`}
                                            style={{ fontSize: "0.68rem" }}
                                            title={`${label}: ${ok ? "Completado" : "Pendiente"}`}
                                        >
                                            <i className={`bi ${ok ? icon : "bi-circle"} me-1`}></i>{label}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            <SeccionTitulo icon="bi-person-lines-fill" title="Información personal" />
                            <Fila label="ID usuario" value={val(u.idUsuario)} icon="bi-fingerprint" />
                            <Fila label="Usuario"    value={val(u.username) ? `@${u.username}` : null} icon="bi-at" />
                            <Fila label="Correo"     value={val(u.email)}      icon="bi-envelope" />
                            <Fila label="Teléfono"   value={val(u.telefono)}   icon="bi-telephone" />
                            <Fila label="Ciudad"     value={val(u.ciudad)}     icon="bi-geo-alt" />
                            <Fila label="País"       value={val(u.pais)}       icon="bi-globe-americas" />
                            <Fila label="Registrado" value={formatearFecha(u.createdAt)} icon="bi-calendar3" />
                            <Fila label="Última actualización" value={formatearFecha(u.updatedAt)} icon="bi-clock-history" />

                            <hr className="my-3" />

                            <SeccionTitulo icon="bi-card-text" title="Identificación" />
                            <Fila label="Tipo de documento" value={val(u.tipoIdentificacion)} icon="bi-journal-text" />
                            <Fila label="Número de documento" value={val(u.identificacion)} icon="bi-hash" />
                            <div className="mt-2">
                                <div className="text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>Verificación de identidad</div>
                                <span className={`badge rounded-pill px-3 py-2 mt-1 ${verfEstado.cls}`}>
                                    {verfEstado.label}
                                </span>
                                {u.verificacionIdentidad?.intentos > 0 && (
                                    <span className="text-muted small ms-2">{u.verificacionIdentidad.intentos} intento{u.verificacionIdentidad.intentos !== 1 ? "s" : ""}</span>
                                )}
                            </div>

                            <hr className="my-3" />

                            <SeccionTitulo icon="bi-link-45deg" title="Conexiones" />
                            <div className="d-flex flex-column gap-2 mt-1">
                                <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-google text-muted"></i>
                                    <span className="small text-dark">Google</span>
                                    <span className={`badge ms-auto rounded-pill ${val(u.googleId) ? "bg-success-subtle text-success-emphasis" : "bg-light text-muted border"}`}>
                                        {val(u.googleId) ? "Conectado" : "No vinculado"}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-apple text-muted"></i>
                                    <span className="small text-dark">Apple</span>
                                    <span className={`badge ms-auto rounded-pill ${val(u.appleId) ? "bg-success-subtle text-success-emphasis" : "bg-light text-muted border"}`}>
                                        {val(u.appleId) ? "Conectado" : "No vinculado"}
                                    </span>
                                </div>
                            </div>

                            <hr className="my-3" />

                            <SeccionTitulo icon="bi-phone" title="Dispositivos" />
                            {dispositivosActivos.length === 0 ? (
                                <p className="text-muted small mb-0">Sin dispositivos registrados.</p>
                            ) : (
                                <div className="d-flex flex-column gap-2">
                                    {dispositivosActivos.map((d, i) => (
                                        <div key={i} className="d-flex align-items-center gap-2 small p-2 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                                            <i className={`bi ${d.plataforma === "android" ? "bi-android2 text-success" : d.plataforma === "ios" ? "bi-apple text-dark" : "bi-display text-primary"}`} style={{ fontSize: "1rem" }}></i>
                                            <div className="flex-grow-1">
                                                <div className="text-dark fw-medium">
                                                    {val(d.dispositivo) ? d.dispositivo : <span className="text-capitalize">{d.plataforma}</span>}
                                                </div>
                                                {val(d.dispositivo) && (
                                                    <div className="text-muted text-capitalize" style={{ fontSize: "0.72rem" }}>{d.plataforma}</div>
                                                )}
                                            </div>
                                            {d.ultimoUso && (
                                                <span className="text-muted flex-shrink-0" style={{ fontSize: "0.72rem" }}>
                                                    {new Date(d.ultimoUso).toLocaleDateString("es-CO")}
                                                </span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            <hr className="my-3" />

                            <SeccionTitulo icon="bi-people" title="Referidos" />
                            <Fila label="Referido por" value={val(u.referidoPor)} icon="bi-person-heart" />
                            <Fila label="Usuarios referidos" value={u.referidos?.length > 0 ? `${u.referidos.length} usuario${u.referidos.length !== 1 ? "s" : ""}` : null} icon="bi-person-plus" />
                            <div className="d-flex align-items-center gap-2 mt-2 small text-muted">
                                <i className={`bi ${u.aceptaMarketing ? "bi-check-circle-fill text-success" : "bi-x-circle text-muted"}`}></i>
                                {u.aceptaMarketing ? "Acepta marketing" : "No acepta marketing"}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Columna derecha: profesional + bancaria */}
                <div className="col-12 col-lg-8 d-flex flex-column gap-4">

                    {/* Perfil profesional */}
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                            <SeccionTitulo icon="bi-briefcase-fill" title="Perfil profesional" />

                            {!tieneProfesional ? (
                                <p className="text-muted small mb-0">Este usuario no ha completado su perfil profesional.</p>
                            ) : (
                                <>
                                    <div className="row g-0">
                                        <div className="col-12 col-sm-6">
                                            <Fila label="Título profesional"     value={val(u.perfilProfesional?.tituloProfesional)} icon="bi-mortarboard" />
                                            <Fila label="Profesión principal"    value={val(u.perfilProfesional?.profesionPrincipal)} icon="bi-person-workspace" />
                                            <Fila label="Empresa actual"         value={val(u.perfilProfesional?.empresaActual)} icon="bi-building" />
                                            <Fila label="Cargo actual"           value={val(u.perfilProfesional?.cargoActual)} icon="bi-award" />
                                            <Fila label="Años de experiencia"    value={u.perfilProfesional?.anosExperiencia > 0 ? `${u.perfilProfesional.anosExperiencia} años` : null} icon="bi-hourglass-split" />
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            {u.perfilProfesional?.habilidades?.length > 0 && (
                                                <div className="py-2 border-bottom">
                                                    <div className="text-muted mb-2" style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>Habilidades</div>
                                                    <div className="d-flex flex-wrap gap-1">
                                                        {u.perfilProfesional.habilidades.map((h, i) => (
                                                            <span key={i} className="badge rounded-pill bg-primary-subtle text-primary-emphasis border border-primary-subtle">{h}</span>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {u.perfilProfesional?.idiomas?.length > 0 && (
                                                <div className="py-2 border-bottom">
                                                    <div className="text-muted mb-2" style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>Idiomas</div>
                                                    <div className="d-flex flex-wrap gap-1">
                                                        {u.perfilProfesional.idiomas.map((id, i) => (
                                                            <span key={i} className="badge rounded-pill bg-light text-secondary border">{id}</span>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {val(u.perfilProfesional?.descripcionProfesional) && (
                                        <div className="mt-3 p-3 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                                            <div className="text-muted mb-1" style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>Descripción</div>
                                            <p className="mb-0 small text-dark">{u.perfilProfesional.descripcionProfesional}</p>
                                        </div>
                                    )}

                                    {u.perfilProfesional?.educacion?.length > 0 && (
                                        <div className="mt-3">
                                            <div className="text-muted mb-2" style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                                <i className="bi bi-book me-1"></i>Educación
                                            </div>
                                            {u.perfilProfesional.educacion.map((e, i) => (
                                                <div key={i} className="d-flex gap-2 mb-2 p-2 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                                                    <i className="bi bi-mortarboard text-muted mt-1"></i>
                                                    <div>
                                                        <div className="small fw-semibold">{val(e.titulo) || "Sin título"}</div>
                                                        <div className="small text-muted">{[val(e.institucion), val(e.area), e.anioFinalizacion > 0 ? e.anioFinalizacion : null].filter(Boolean).join(" · ")}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {u.perfilProfesional?.certificaciones?.length > 0 && (
                                        <div className="mt-3">
                                            <div className="text-muted mb-2" style={{ fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                                <i className="bi bi-patch-check me-1"></i>Certificaciones
                                            </div>
                                            {u.perfilProfesional.certificaciones.map((c, i) => (
                                                <div key={i} className="d-flex gap-2 mb-2 p-2 rounded-3" style={{ background: "var(--color-track-bg)" }}>
                                                    <i className="bi bi-patch-check-fill text-primary mt-1"></i>
                                                    <div>
                                                        <div className="small fw-semibold">{val(c.nombre) || "Sin nombre"}</div>
                                                        <div className="small text-muted">
                                                            {[val(c.entidad), c.anio > 0 ? c.anio : null].filter(Boolean).join(" · ")}
                                                            {val(c.urlCredencial) && (
                                                                <a href={c.urlCredencial} target="_blank" rel="noopener noreferrer" className="ms-2 small">Ver credencial</a>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Cuentas bancarias */}
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                            <SeccionTitulo icon="bi-bank2" title="Cuentas bancarias" />
                            {!tieneBancaria ? (
                                <p className="text-muted small mb-0">No tiene cuentas bancarias registradas.</p>
                            ) : (
                                <div className="d-flex flex-column gap-3">
                                    {u.cuentasBancarias.map((c) => {
                                        const esEscogida = u.cuentaBancariaEscogida === c.idCuentaBancaria;
                                        return (
                                            <div key={c.idCuentaBancaria} className="p-3 rounded-3 border" style={{ background: esEscogida ? "rgba(var(--azul-bootstrap-cta-rgb), 0.04)" : undefined }}>
                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <span className="fw-semibold small">{c.banco}</span>
                                                    <div className="d-flex gap-1">
                                                        <span className="badge rounded-pill bg-light text-secondary border">{c.tipoCuenta}</span>
                                                        {esEscogida && <span className="badge rounded-pill bg-primary-subtle text-primary-emphasis border border-primary-subtle">Principal</span>}
                                                    </div>
                                                </div>
                                                <div className="small text-muted d-flex flex-column gap-1">
                                                    <span><i className="bi bi-hash me-1"></i>{c.numeroCuenta}</span>
                                                    <span><i className="bi bi-person me-1"></i>{c.nombreTitular} · {c.identificacionTitular}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {tieneWallets && (
                                <>
                                    <hr className="my-3" />
                                    <SeccionTitulo icon="bi-currency-bitcoin" title="Wallets cripto" />
                                    <div className="d-flex flex-column gap-2">
                                        {u.wallets.map((w) => {
                                            const esEscogida = u.walletEscogida === w.idWallet;
                                            return (
                                                <div key={w.idWallet} className="p-3 rounded-3 border" style={{ background: esEscogida ? "rgba(var(--amarillo-warning-variante-rgb), 0.06)" : undefined }}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="fw-semibold small">{w.tipoCripto}</span>
                                                        {esEscogida && <span className="badge rounded-pill bg-warning-subtle text-warning-emphasis border border-warning-subtle">Principal</span>}
                                                    </div>
                                                    <div className="small text-muted mt-1 text-break">{w.numeroWallet}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Reservas — dentro de la columna derecha */}
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-2 mb-4">
                                <i className="bi bi-calendar2-check text-primary"></i>
                                <h6 className="mb-0 fw-bold text-dark">Reservas</h6>
                            </div>

                            {/* Pestañas */}
                            <div className="d-flex gap-2 mb-4">
                                {[
                                    { key: "comprador", label: "Como comprador", icon: "bi-bag-check" },
                                    { key: "proveedor", label: "Como vendedor",  icon: "bi-briefcase" },
                                ].map((t) => (
                                    <button
                                        key={t.key}
                                        type="button"
                                        className={`btn btn-sm rounded-pill px-3 ${tabReservas === t.key ? "btn-primary" : "btn-outline-secondary"}`}
                                        onClick={() => cambiarTabReservas(t.key)}
                                    >
                                        <i className={`bi ${t.icon} me-1`}></i>{t.label}
                                    </button>
                                ))}
                            </div>

                            {/* Contenido tab activo */}
                            {(() => {
                                const estado = tabReservas === "comprador" ? reservasComprador : reservasProveedor;
                                const fmt = (n) => new Intl.NumberFormat("es-CO").format(n || 0);

                                if (estado.cargando) {
                                    return (
                                        <div className="text-center py-4">
                                            <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                                            <p className="text-muted small mt-2 mb-0">Cargando reservas...</p>
                                        </div>
                                    );
                                }

                                if (!estado.data.length) {
                                    return (
                                        <div className="text-center py-4 text-muted">
                                            <i className="bi bi-calendar-x fs-3 d-block mb-2" style={{ opacity: 0.3 }}></i>
                                            <span className="small">No hay reservas como {tabReservas === "comprador" ? "comprador" : "vendedor"}.</span>
                                        </div>
                                    );
                                }

                                return (
                                    <div className="d-flex flex-column gap-2">
                                        {estado.data.slice(0, 5).map((r) => {
                                            const estReserva = ESTADO_RESERVA[r.estado] || ESTADO_RESERVA.expirado;
                                            const fecha = r.fecha || r.inicio || r.createdAt;
                                            const fechaStr = fecha ? new Date(fecha).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" }) : "—";
                                            const contraparteNombre = [val(r.contraparte?.nombre), val(r.contraparte?.apellido)].filter(Boolean).join(" ");
                                            return (
                                                <div
                                                    key={r._id}
                                                    className="d-flex flex-column flex-sm-row align-items-sm-center gap-3 p-3 rounded-3 border"
                                                    style={{ cursor: "pointer", transition: "background 0.15s" }}
                                                    onClick={() => navigate("/admin/reserva-admin", { state: { params: { idReserva: r._id } } })}
                                                    onMouseEnter={(e) => e.currentTarget.style.background = "var(--color-track-bg)"}
                                                    onMouseLeave={(e) => e.currentTarget.style.background = ""}
                                                >
                                                    <div className="flex-grow-1 min-width-0">
                                                        <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                            <span className="fw-semibold small text-dark text-truncate">{r.nombreServicio}</span>
                                                            <span className="badge rounded-pill bg-light text-secondary border" style={{ fontSize: "0.7rem" }}>{r.tipoPaquete}</span>
                                                            {r.reclamo?.abierto && (
                                                                <span className="badge rounded-pill bg-danger-subtle text-danger-emphasis border border-danger-subtle" style={{ fontSize: "0.7rem" }}>
                                                                    <i className="bi bi-exclamation-triangle-fill me-1"></i>Reclamo
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="text-muted d-flex gap-3 flex-wrap" style={{ fontSize: "0.78rem" }}>
                                                            <span><i className="bi bi-calendar3 me-1"></i>{fechaStr}</span>
                                                            {r.horaSolicitada && r.horaSolicitada !== "NA" && (
                                                                <span><i className="bi bi-clock me-1"></i>{r.horaSolicitada}</span>
                                                            )}
                                                        </div>
                                                        {val(r.contraparte?.username) && (
                                                            <div className="d-flex align-items-center gap-2 mt-1" style={{ fontSize: "0.78rem" }}>
                                                                <img
                                                                    src={val(r.contraparte?.avatar) || "/imagenes/marca/avatar.png"}
                                                                    alt=""
                                                                    className="rounded-circle"
                                                                    style={{ width: 18, height: 18, objectFit: "cover" }}
                                                                />
                                                                <span className="text-muted">
                                                                    {tabReservas === "comprador" ? "Vendedor:" : "Comprador:"}
                                                                    {" "}<span className="text-dark fw-medium">@{r.contraparte.username}</span>
                                                                    {contraparteNombre ? ` · ${contraparteNombre}` : ""}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="d-flex align-items-center gap-3 flex-shrink-0">
                                                        <span className="fw-semibold text-dark" style={{ fontSize: "0.9rem" }}>
                                                            ${fmt(r.cobro?.montoTotal)}
                                                        </span>
                                                        <span className={`badge rounded-pill px-3 py-2 ${estReserva.cls}`} style={{ fontSize: "0.72rem" }}>
                                                            {estReserva.label}
                                                        </span>
                                                        <i className="bi bi-chevron-right text-muted" style={{ fontSize: "0.75rem" }}></i>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                        {estado.data.length > 5 && (
                                            <p className="text-muted small text-center mt-2 mb-0">
                                                Mostrando las últimas 5 reservas.
                                            </p>
                                        )}
                                    </div>
                                );
                            })()}
                        </div>
                    </div>

                    {/* Servicios */}
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-2 mb-4 flex-wrap">
                                <i className="bi bi-briefcase text-primary"></i>
                                <h6 className="mb-0 fw-bold text-dark">Servicios</h6>
                                <span className="badge bg-light text-secondary border ms-1" style={{ fontSize: "0.7rem" }}>Borrador · Aprobado</span>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary rounded-3 ms-auto d-inline-flex align-items-center gap-1"
                                    style={{ fontSize: "0.8rem" }}
                                    onClick={crearServicioParaUsuario}
                                    disabled={creandoSrv}
                                >
                                    {creandoSrv
                                        ? <><span className="spinner-border spinner-border-sm" style={{ width: 12, height: 12 }} />Creando...</>
                                        : <><i className="bi bi-plus-circle"></i>Crear servicio</>
                                    }
                                </button>
                            </div>

                            {cargandoSrv ? (
                                <div className="text-center py-4">
                                    <span className="spinner-border spinner-border-sm text-primary" role="status" />
                                </div>
                            ) : servicios.length === 0 ? (
                                <div className="text-center py-4 text-muted">
                                    <i className="bi bi-briefcase fs-3 d-block mb-2" style={{ opacity: 0.3 }}></i>
                                    <span className="small">No tiene servicios en borrador ni aprobados.</span>
                                </div>
                            ) : (
                                <div className="d-flex flex-column gap-2">
                                    {servicios.slice(0, 5).map((s) => {
                                        const BADGE = {
                                            Borrador: { bg: "rgba(var(--gris-suave-rgb), 0.1)", color: "var(--gris-suave)", label: "Borrador" },
                                            Aprobado: { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)", label: "Aprobado" },
                                        };
                                        const est    = BADGE[s.estado] || BADGE.Borrador;
                                        const imagen = s.imagenes?.[0] || null;
                                        const precios = (s.paquetes || []).map(p => p.precio).filter(n => n > 0);
                                        const precioMin = precios.length ? Math.min(...precios) : null;
                                        const precioMax = precios.length ? Math.max(...precios) : null;
                                        const fmtP = n => "$" + new Intl.NumberFormat("es-CO").format(n);
                                        return (
                                            <div
                                                key={s.idServicio}
                                                className="d-flex align-items-center gap-3 p-3 rounded-3 border"
                                                style={{ cursor: "pointer", transition: "background 0.15s" }}
                                                onClick={() => navigate("/admin/servicio", { state: { params: { idServicio: s.idServicio } } })}
                                                onMouseEnter={e => e.currentTarget.style.background = "var(--color-track-bg)"}
                                                onMouseLeave={e => e.currentTarget.style.background = ""}
                                            >
                                                {imagen && (
                                                    <img src={imagen} alt={s.nombre} className="rounded-3 flex-shrink-0" style={{ width: 52, height: 52, objectFit: "cover" }} />
                                                )}
                                                <div className="flex-grow-1 min-width-0">
                                                    <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                        <span className="fw-semibold small text-dark text-truncate">{s.nombre && s.nombre !== "NA" ? s.nombre : "Sin título"}</span>
                                                        <span className="badge rounded-pill px-2 py-1" style={{ background: est.bg, color: est.color, fontSize: "0.7rem" }}>{est.label}</span>
                                                    </div>
                                                    <div className="text-muted d-flex flex-wrap gap-3" style={{ fontSize: "0.78rem" }}>
                                                        {s.categoria && s.categoria !== "NA" && <span><i className="bi bi-tag me-1"></i>{s.categoria}</span>}
                                                        {s.tipoServicio && <span><i className="bi bi-laptop me-1"></i>{s.tipoServicio}</span>}
                                                        {precioMin !== null && (
                                                            <span><i className="bi bi-cash me-1"></i>{precioMin === precioMax ? fmtP(precioMin) : `${fmtP(precioMin)} – ${fmtP(precioMax)}`}</span>
                                                        )}
                                                    </div>
                                                </div>
                                                <i className="bi bi-chevron-right text-muted flex-shrink-0" style={{ fontSize: "0.75rem" }}></i>
                                            </div>
                                        );
                                    })}
                                    {servicios.length > 5 && (
                                        <p className="text-muted small text-center mt-2 mb-0">
                                            Mostrando los últimos 5 servicios.
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default UsuarioIndividual;
